import Vue from 'vue';
import Router from 'vue-router';
import HomeComponent from '../components/home-component';
import CategoryWidget from '../components/widgets/category/widget-category';
import MatchDetailsWidget from '../components/widgets/match-details/widget-match-details';
import MatchDetailsWidgetUs from '../components/widgets/match-details/widget-match-details-us';
import MyFavoritePage from '../components/common/favorite-page-component';
import CategoryTabHR from '../components/widgets/category-horse-racing/category-tab-hr';
import SportCategoryList from '../components/widgets/sports-category/sports-tournaments';
import CategoryList from '../components/widgets/sports-category/category-list';
import MybetsInlineComponent from '../components/shared/mybets/mybets-component/observed-mybets';
import BetslipCheckerInline from '../components/shared/mybets/betslip-checker/betslip-checker-inline';
import NegotiationComponentInline from '../components/shared/mybets/negotiation-component-inline';
import { BTO_EVENT_BUS } from '@bto-services/event-bus';
import LiveHorseRacingComponent from '../components/widgets/horse-racing/component-live-horse-racing';
import { userLoggedIn } from '@bto-services/user';

// Don't initialize router when exporting widgets
if (!process.env.VUE_APP_IS_EXPORT) {
  Vue.use(Router);
}

/**
 * Auth guard to check user before routes
 * @type {import('vue-router').NavigationGuard}
 */
const AuthGuard = (_to, _from, next) => {
  if (userLoggedIn()) {
    next();
    return;
  }

  next('/');
};

let routerMode = 'hash';
let baseUrl = '/';
if (!APP_SETTINGS.settings.ignoreRouteConfig && btoSBSettings) {
  routerMode = btoSBSettings.isHistoryMode === '1' ? 'history' : 'hash';
  baseUrl = btoSBSettings.isHistoryMode === '1' && btoSBSettings.baseURLSlug ? `/${btoSBSettings.baseURLSlug}/` : '';
}

const router = new Router({
  mode: routerMode,
  base: baseUrl,
  routes: [
    {
      path: '/favorites',
      component: HomeComponent,
      children: [
        {
          name: 'myfavorites',
          path: '',
          component: MyFavoritePage
        }
      ]
    },
    {
      path: '/mybets',
      component: HomeComponent,
      beforeEnter: AuthGuard,
      children: [
        {
          name: 'myBetsHistory',
          path: '',
          component: MybetsInlineComponent,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ],
    },
    {
      path: '/historycheck',
      component: HomeComponent,
      children: [
        {
          name: 'historyChecker',
          path: '',
          component: BetslipCheckerInline,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ],
    },
    {
      path: '/negotiations',
      component: HomeComponent,
      children: [
        {
          name: 'negotiations',
          path: '',
          component: NegotiationComponentInline,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ],
    },
    {
      path: '/:layoutName?',
      name: 'home',
      component: HomeComponent,
    },
    {
      path: '/game/:matchId',
      component: HomeComponent,
      children: [
        {
          name: 'matchDetailsPrematch',
          path: '',
          component: APP_SETTINGS.settings.layout === 'US' ? MatchDetailsWidgetUs : MatchDetailsWidget,
          meta: {
            hideAfterRouterWidgets: true,
          },
        }
      ],
    },
    {
      path: '/race/:raceDateFilter?/:sportId?/:raceId',
      component: HomeComponent,
      children: [
        {
          name: 'raceDetailsHr',
          path: '',
          component: CategoryTabHR,
          meta: {
            hideAfterRouterWidgets: true,
          },
        }
      ],
    },
    {
      path: '/event-view/:matchType?/:matchId?',
      name: 'matchDetailsLive',
      component: HomeComponent,
    },
    {
      path: '/sports/:fixtureDateFilter?/:fixtureIds?/',
      component: HomeComponent,
      children: [
        {
          name: 'sports',
          path: '',
          component: CategoryWidget,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ],
    },
    {
      path: '/:sportName?/sp-:sportId',
      component: HomeComponent,
      children: [
        {
          name: 'seoSport',
          path: '',
          component: SportCategoryList,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ]
    },
    {
      path: '/:sport?/:category?/sc-:categoryId?',
      component: HomeComponent,
      children: [
        {
          name: 'seoCategory',
          path: '',
          component: CategoryList,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ]
    },
    {
      path: '/:sport?/:category?/scg-:categoryId?',
      component: HomeComponent,
      children: [
        {
          name: 'seoCategoryGroup',
          path: '',
          component: CategoryList,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ]
    },
    {
      path: '/:sportName?/:categoryName?/:eventName?/sm-:matchId',
      component: HomeComponent,
      children: [
        {
          name: 'seoGame',
          path: '',
          component: APP_SETTINGS.settings.layout === 'US' ? MatchDetailsWidgetUs : MatchDetailsWidget,
          meta: {
            hideAfterRouterWidgets: true,
          },
        }
      ],
    },
    {
      path: '/event-view/:sportName?/:categoryName?/:eventName?/sm-:matchId/',
      pathToRegexpOptions: { strict: true },
      name: 'seoGameLive',
      component: HomeComponent,
    },
    {
      path: '/racelive/:sportName?/:categoryName?/sm-:matchId?/:providerId?/:rmgStreamId?/',
      component: HomeComponent,
      children: [
        {
          name: 'liveRace',
          path: '',
          component: LiveHorseRacingComponent,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ]
    },
    {
      path: '/:sport?/:tournament?/st-:fixtureIds',
      component: HomeComponent,
      children: [
        {
          name: 'seoTournament',
          path: '',
          component: APP_SETTINGS.settings.layout === 'US' ? CategoryList : CategoryWidget,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ],
    },
    {
      path: '/:sport?/:tournament?/stg-:fixtureIds',
      component: HomeComponent,
      children: [
        {
          name: 'seoTournamentGroup',
          path: '',
          component: APP_SETTINGS.settings.layout === 'US' ? CategoryList : CategoryWidget,
          meta: {
            hideAfterRouterWidgets: true,
          },
        },
      ],
    },
    {
      path: '/:fixtureDateFilter?/:fixtureIds?/',
      name: 'default',
      component: HomeComponent,
    },
  ],
});

router.beforeEach((to, from, next) => {
  next();
  BTO_EVENT_BUS.emit('routeChange', {
    to: {
      path: to.path,
      fullPath: to.fullPath,
      params: to.params,
      query: to.query,
    },
    from: {
      path: from.path,
      fullPath: from.fullPath,
      params: from.params,
      query: from.query,
    },
  });
  if (APP_SETTINGS.settings.allowGlobalScroll && router.app.$el) {
    router.app.$el.scrollIntoView({ behavior: "smooth" });
  }
});

BTO_EVENT_BUS.on('navigateTo', (path) => {
  router.push(path).catch(() => { });
});

export default router;